module.exports = __webpack_public_path__ + "static/ecogiraffetoy-6b7e382e222ea96dd7a6ecd697389763.jpeg";